"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Checkboxer = require("./Checkboxer.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * checkbox / radio group
 */
const CheckGroup = _antd.Checkbox.Group;
const RadioGroup = _antd.Radio.Group;
const Checkboxer = _ref => {
  let {
    label,
    options = [],
    value,
    onChange,
    disabled = false,
    className
  } = _ref;
  const onChangeHandle = value => {
    onChange && onChange(value);
  };
  return /*#__PURE__*/_react.default.createElement(_Checkboxer.UiCheckboxer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/_react.default.createElement(CheckGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map((option, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: option.code
    }, option.name));
  }))));
};
const Radio = _ref2 => {
  let {
    label,
    options = [],
    value,
    onChange,
    disabled = false,
    className
  } = _ref2;
  const onChangeHandle = event => {
    onChange && onChange(event.target.value, event);
  };
  return /*#__PURE__*/_react.default.createElement(_Checkboxer.UiCheckboxer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/_react.default.createElement(RadioGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map((option, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: option.code
    }, option.name));
  }))));
};
exports.Radio = Radio;
var _default = exports.default = Checkboxer;
Checkboxer.propTypes = {
  label: _propTypes.default.string,
  options: _propTypes.default.array,
  value: _propTypes.default.array,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};
Radio.propTypes = {
  label: _propTypes.default.string,
  options: _propTypes.default.array,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};